module.exports = {
	"v": "5.0.5",
	"fr": 30,
	"ip": 0,
	"op": 61,
	"w": 400,
	"h": 506,
	"nm": "Hero_image",
	"ddd": 0,
	"assets": [
		{
			"id": "image_0",
			"w": 148,
			"h": 96,
			"u": "https://cdn.auth0.com/website/financial-services/images/hero/",
			"p": "img_0_1.png"
		},
		{
			"id": "image_1",
			"w": 160,
			"h": 96,
			"u": "https://cdn.auth0.com/website/financial-services/images/hero/",
			"p": "img_1_1.png"
		},
		{
			"id": "image_2",
			"w": 145,
			"h": 96,
			"u": "https://cdn.auth0.com/website/financial-services/images/hero/",
			"p": "img_2_1.png"
		},
		{
			"id": "image_3",
			"w": 223,
			"h": 98,
			"u": "https://cdn.auth0.com/website/financial-services/images/hero/",
			"p": "img_3_1.png"
		},
		{
			"id": "image_4",
			"w": 242,
			"h": 487,
			"u": "https://cdn.auth0.com/website/financial-services/images/hero/",
			"p": "img_4_1.png"
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 3,
			"nm": "size",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 0,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						200,
						253,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 2,
			"nm": "Banking",
			"parent": 1,
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 0,
							"s": [
								0
							],
							"e": [
								100
							]
						},
						{
							"t": 11
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70.353,
						-113.228,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						73.567,
						47.556,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 2,
			"nm": "Insurance",
			"parent": 1,
			"refId": "image_1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 10,
							"s": [
								0
							],
							"e": [
								100
							]
						},
						{
							"t": 21
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						-117.724,
						-39.349,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						79.643,
						47.556,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 2,
			"nm": "FinTech",
			"parent": 1,
			"refId": "image_2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 20,
							"s": [
								0
							],
							"e": [
								100
							]
						},
						{
							"t": 31
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						126.853,
						12.772,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						72.067,
						47.556,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 2,
			"nm": "Asset Managment",
			"parent": 1,
			"refId": "image_3",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 30,
							"s": [
								0
							],
							"e": [
								100
							]
						},
						{
							"t": 41
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						67.419,
						138.772,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						111.5,
						48.602,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 2,
			"nm": "hero image",
			"parent": 1,
			"refId": "image_4",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						-9.581,
						0.203,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						120.75,
						243.25,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 627,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/financial-services/animations/hero/data.json
// module id = 1384
// module chunks = 0